module.exports = __webpack_public_path__ + "img/main-logo.5b222b1b.png";